export const formatPriceFromPence = (priceInPence, currency = '£') => {
    const price = priceInPence / 100

    return `${currency}${price.toFixed(2)}`
}
